import React from 'react';
import Type from 'prop-types';
import {
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from "@mui/material";
import { useToggle } from 'react-use';
import { FormattedNumber, FormattedDate } from 'components';
import { fullDateFormat } from 'constants/dateFormats';
import { useTranslation } from 'hooks';
import PromiseForm from '../PromiseForm';
import styles from './PromiseItem.module.css';

const PromiseItem = (props) => {
  const {
    promise: {
      amount,
      author,
      result,
      due,
      contactName,
      contactPhone,
      createdAt,
      comment,
    },
  } = props;
  const { t } = useTranslation();
  const [isOpenedDialog, toggleOpenDialog] = useToggle(false);

  const openDialog = (event) => {
    event.stopPropagation();
    toggleOpenDialog();
  };

  const renderPromiseCard = () => {
    return (
      <ListItem button onClick={openDialog}>
        <ListItemText
          primary={`${t('employee')}: ${author.name}`}
          secondary={result && result.name.length > 0 ? result.name : null}
          secondaryTypographyProps={{
            classes: {
              root: styles.comment,
            },
          }}
        />

        <ListItemSecondaryAction>
          <div className={styles.actionContainer}>
            <FormattedNumber
              classes={{ root: styles.amount }}
              value={amount}
              options={{
                currency: 'RUB',
                style: 'currency',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }}
              color="textPrimary"
              variant="body1"
              component="span"
            />
            {due && (
              <FormattedDate
                value={due}
                token={fullDateFormat}
                color="primary"
                variant="body2"
              />
            )}
          </div>
        </ListItemSecondaryAction>
      </ListItem>
    );
  };

  const renderPromiseDialog = () => {
    return (
      <PromiseForm
        open={isOpenedDialog}
        onClose={toggleOpenDialog}
        values={{
          employee: author.name,
          due,
          contactName,
          contactPhone,
          createdAt,
          comment,
          amount,
        }}
      />
    );
  };

  return isOpenedDialog ? renderPromiseDialog() : renderPromiseCard();
};

PromiseItem.propTypes = {
  promise: Type.shape({
    id: Type.string.isRequired,
    createdAt: Type.string.isRequired,
    amount: Type.number,
    comment: Type.string,
    contactName: Type.string,
    contactPhone: Type.string,
    due: Type.string,
    author: Type.shape({
      id: Type.string.isRequired,
      name: Type.string.isRequired,
    }),
    result: Type.shape({
      id: Type.string.isRequired,
      name: Type.string.isRequired,
    }),
    type: Type.shape({
      id: Type.string,
      name: Type.string,
    }),
  }).isRequired,
};

export default PromiseItem;
